var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-result',{attrs:{"status":"500","title":"Please sildeload Addins","subTitle":"Vui lòng mở trong addins."}})}
var staticRenderFns = []

export { render, staticRenderFns }